import Vue from 'vue';
import Errors from '../classes/errors';

Vue.component('newsletter-signup-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            errors: new Errors(),
            success: false,
            fields: {
                email: '',
            },
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        onSubmit(event) {
            this.submitting = true;
            this.errors.clear();

            this.$axios.post('/actions/girelated-files/default/subscribe', this.fields)
                .then((response) => {
                    this.submitting = false;

                    if (!response.data.success) {
                        console.error('An error occured while subscribing to the newsletter', response.data);
                    }

                    this.handleSuccess(response.data);
                })
                .catch((error) => {
                    this.handleErrors(error);
                    this.success = false;
                });
        },

        handleErrors(error) {
            this.errors.record(error.data.errors);
        },

        handleSuccess() {
            this.errors.clear();
            this.success = true;
        },
    },
});
